import React, { useState, useEffect } from "react";

// --- Constants ---
const ACCENT = "#635bff";
export const MAIN_PAGE_IMAGE = "/images/main.png";
const BTC_ADDRESS = "bc1qrsj78t6hh7hheukkvkehakk6ht942v6h7v6yf7";
const TELEGRAM = "@fakeidlordak47";
const WHATSAPP = "+1 205 557 9964";
const WHATSAPP_LINK = "https://wa.me/12055579964";
const FORMSPREE_ENDPOINT = "https://formspree.io/f/mrbyzdka";

// --- Google Analytics (added) ---
const GA_ID = "G-6NWS9TGPGB";

// --- States Data (original values kept here; we adjust below) ---
const STATES_DATA = [
  {
    key: "Alabama",
    front: "/images/al front.png",
    back: "/images/al back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Great for Alabama-area venues, college towns, and out-of-state travel—often accepted with minimal questions.",
      "Scan Performance: Alabama templates scan reliably across standard club/bar scanners and POS systems when encoded correctly.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Alaska",
    front: "/images/ak front.png",
    back: "/images/ak back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Great for out-of-state use—rarely questioned in the lower 48 and a solid pick for college towns and travel.",
      "Scan Performance: Alaska’s unique visual elements make it an eye-catching template that still performs well on club/bar scanners when encoded accurately.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Arizona",
    front: "/images/az front.png",
    back: "/images/az back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Popular for desert-region travel, out-of-state presentations, and student life in large Arizona college towns.",
      "Scan Performance: Arizona templates are generally reliable on standard scanners and perform well in busy nightlife environments.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Arkansas",
    front: "/images/ar front.png",
    back: "/images/ar back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Well-suited for Arkansas-area venues, college nightlife, and regional travel where dependable templates are needed.",
      "Scan Performance: Arkansas designs balance authenticity and scan reliability for club/bar checks when properly encoded.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "California",
    front: "/images/ca front.png",
    back: "/images/ca back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Ideal for California’s nightlife, large clubs, and out-of-state travel into more permissive regions.",
      "Scan Performance: California templates scan well at busier venues and are recognized by many standard scanning systems when encoded correctly.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Colorado",
    front: "/images/co front.png",
    back: "/images/co back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Great for Colorado ski towns, craft breweries, and student communities where a convincing ID is important.",
      "Scan Performance: Colorado templates maintain solid scanner compatibility and hold up well in venue checks when encoded properly.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Connecticut",
    front: "/images/ct front.png",
    back: "/images/ct back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Well-suited for Connecticut nightlife scenes, suburban venues, and short-range travel where reliability matters.",
      "Scan Performance: Connecticut templates perform consistently on most standard barcode readers and club scanners.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Delaware",
    front: "/images/de front.png",
    back: "/images/de back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Good for Delaware-area bars, campus scenes, and travel across nearby states where acceptance is important.",
      "Scan Performance: Delaware templates are reliable with standard scanners and tend to pass casual spot checks when encoded correctly.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Florida",
    front: "/images/fl front.png",
    back: "/images/fl back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Excellent for Florida club scenes, major tourist areas, and spring break environments requiring high-quality templates.",
      "Scan Performance: Florida designs scan consistently at high-volume venues; encoding quality matters for reliable reads.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Georgia",
    front: "/images/ga front.png",
    back: "/images/ga back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Popular with Georgia college communities, downtown club scenes, and for regional travel.",
      "Scan Performance: Georgia templates are trusted for consistent scanner reads when properly encoded and finished.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Hawaii",
    front: "/images/hi front.png",
    back: "/images/hi back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Great for island travel, resort-area venues, and situations where an authentic-looking ID is required.",
      "Scan Performance: Hawaii templates are distinctive but still provide stable scanner performance when barcodes are encoded correctly.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Idaho",
    front: "/images/id front.png",
    back: "/images/id back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Works well in Idaho college towns, local venues, and for regional travel into neighboring states.",
      "Scan Performance: Idaho templates scan consistently when encoded by our production team and hand-verified before shipping.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Indiana",
    front: "/images/in front.png",
    back: "/images/in back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Great for Indiana college campuses, sports event nightlife, and local urban venues.",
      "Scan Performance: Indiana templates perform well on most handheld and fixed scanners when encoded accurately.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Iowa",
    front: "/images/ia front.png",
    back: "/images/ia back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Strong for Iowa college bars, small-city nightlife, and regional travel into neighboring Midwest states.",
      "Scan Performance: Iowa templates scan reliably on standard club/bar readers with clean encoding and hand verification.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Kansas",
    front: "/images/ks front.png",
    back: "/images/ks back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Good for Kansas college scenes, local music venues, and short regional travel where authenticity matters.",
      "Scan Performance: Kansas templates are stable on most barcode readers when encoded and checked by our production team.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Kentucky",
    front: "/images/ky front.png",
    back: "/images/ky back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Ideal for Kentucky college nightlife, Bourbon Trail-area venues, and out-of-state travel.",
      "Scan Performance: Kentucky templates deliver solid scanner compatibility when barcodes are encoded accurately and professionally.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Louisiana",
    front: "/images/la front.png",
    back: "/images/la back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Designed for Louisiana nightlife, festival scenes, and urban venues where detailed templates are essential.",
      "Scan Performance: Louisiana templates scan well with standard equipment and are competitive in high-volume venues when encoded properly.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Maine",
    front: "/images/me front.png",
    back: "/images/me back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Works well for Maine coastal venues, university towns, and regional travel across New England.",
      "Scan Performance: Maine templates are generally reliable on handheld and fixed scanners when encoded properly.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Maryland",
    front: "/images/md front.png",
    back: "/images/md back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Suitable for Maryland metro nightlife, college communities, and travel into neighboring states.",
      "Scan Performance: Maryland templates maintain strong scanner compatibility when barcode encoding is done by our team.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Massachusetts",
    front: "/images/ma front.png",
    back: "/images/ma back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Excellent for Massachusetts college towns, Boston nightlife, and events where high-quality ID presentation is required.",
      "Scan Performance: Massachusetts templates are reliable on club scanners and commonly used verification systems when encoded properly.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Michigan",
    front: "/images/mi front.png",
    back: "/images/mi back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Well-suited for Michigan college towns, Detroit-area nightlife, and region-wide travel.",
      "Scan Performance: Michigan templates provide consistent scanner reads when encoded and finished to our quality standards.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Minnesota",
    front: "/images/mn front.png",
    back: "/images/mn back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Great for Minnesota venue scenes, college nightlife, and regional events that require convincing IDs.",
      "Scan Performance: Minnesota templates scan dependably on most standard readers when encoded and verified by our production process.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Mississippi",
    front: "/images/ms front.png",
    back: "/images/ms back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Solid option for Mississippi nightlife, local bars, and regional travel where realistic IDs are needed.",
      "Scan Performance: Mississippi templates perform well on handheld and fixed scanners when encoded accurately.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Missouri",
    front: "/images/mo front.png",
    back: "/images/mo back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Good choice for Missouri college nightlife, urban venues, and regional travel where authenticity helps.",
      "Scan Performance: Missouri templates are compatible with most scanners and perform well in routine checks when encoded correctly.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Montana",
    front: "/images/mt front.png",
    back: "/images/mt back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Works well in Montana’s smaller towns, university venues, and regional travel where strong visuals are an advantage.",
      "Scan Performance: Montana templates are reliable in scanner checks when barcode/data encoding is applied correctly.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Nebraska",
    front: "/images/ne front.png",
    back: "/images/ne back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Popular for Nebraska college scenes, local bars, and regional travel into nearby states.",
      "Scan Performance: Nebraska templates deliver dependable scanning results when produced and verified by our team.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Nevada",
    front: "/images/nv front.png",
    back: "/images/nv back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Ideal for Nevada nightlife, Las Vegas venues, and high-volume club environments where an authentic template is crucial.",
      "Scan Performance: Nevada templates are designed to scan well in high-traffic clubs and venues when encoded to spec.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "New Hampshire",
    front: "/images/nh front.png",
    back: "/images/nh back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Great for New Hampshire college scenes, smaller-town nightlife, and short-distance travel across New England.",
      "Scan Performance: New Hampshire templates scan effectively on most standard scanners when produced to our quality standards.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "New Jersey",
    front: "/images/nj front.png",
    back: "/images/nj back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Popular for New Jersey metro nightlife, college scenes, and regional travel into NYC-suburban venues.",
      "Scan Performance: New Jersey templates are built to scan well on common handheld scanners used in busy clubs and bars.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "New Mexico",
    front: "/images/nm front.png",
    back: "/images/nm back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Works well for New Mexico college venues, festivals, and local nightlife where authenticity matters.",
      "Scan Performance: New Mexico templates provide reliable reads on standard scanners when encoded correctly and verified.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "New York",
    front: "/images/ny front.png",
    back: "/images/ny back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Excellent for NYC-area nightlife, major clubs, and events where realistic presentation is essential.",
      "Scan Performance: New York templates are optimized to perform well on modern club scanners and handheld readers when encoded properly.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "North Carolina",
    front: "/images/nc front.png",
    back: "/images/nc back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Great for North Carolina college towns, urban nightlife, and festival scenes across the state.",
      "Scan Performance: North Carolina templates are consistent with most scanning solutions when encoded and verified to spec.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Ohio",
    front: "/images/oh front.png",
    back: "/images/oh back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Excellent for Ohio-state college scenes, city nightlife, and events requiring dependable ID presentation.",
      "Scan Performance: Ohio templates provide good scanner compatibility and are used successfully in many venue checks when encoded properly.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Oklahoma",
    front: "/images/ok front.png",
    back: "/images/ok back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Works well in Oklahoma college hubs, local bars, and for inter-state travel where reliable templates matter.",
      "Scan Performance: Oklahoma templates are compatible with common scanning systems when produced with precise encoding.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Oregon",
    front: "/images/or front.png",
    back: "/images/or back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Excellent for Oregon college towns, urban nightlife, and festival venues across the state.",
      "Scan Performance: Oregon templates are designed to scan reliably on modern readers when encoded and checked by our production workflow.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Pennsylvania",
    front: "/images/pa front.png",
    back: "/images/pa back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Great for Pennsylvania college nightlife, city venues, and regional travel where authenticity is valued.",
      "Scan Performance: Pennsylvania templates scan effectively on standard readers when produced with accurate encoding and verification.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Rhode Island",
    front: "/images/ri front.png",
    back: "/images/ri back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Ideal for Rhode Island college scenes, small-city nightlife, and regional travel around New England.",
      "Scan Performance: Rhode Island templates scan reliably on most standard scanners when produced to our production standards.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "South Carolina",
    front: "/images/sc front.png",
    back: "/images/sc back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Great for South Carolina college nightlife, beach towns, and festival scenes requiring convincing templates.",
      "Scan Performance: South Carolina templates scan consistently on handheld and fixed readers when encoded properly.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Tennessee",
    front: "/images/tn front.png",
    back: "/images/tn back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Excellent for Tennessee music venues, college towns, and nightlife where realistic IDs are beneficial.",
      "Scan Performance: Tennessee templates provide stable scanner reads when encoded correctly and verified in production.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Texas",
    front: "/images/tx front.png",
    back: "/images/tx back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Ideal for Texas urban nightlife, large clubs, and festival scenes where realistic templates are essential.",
      "Scan Performance: Texas templates are optimized to scan well in high-volume venues when barcodes and data are encoded properly.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Utah",
    front: "/images/ut front.png",
    back: "/images/ut back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Great for Utah college towns, ski-resort areas, and regional venues where authenticity helps.",
      "Scan Performance: Utah templates perform reliably on most scanning equipment when encoded and checked in production.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Vermont",
    front: "/images/vt front.png",
    back: "/images/vt back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Excellent for Vermont college venues, ski towns, and local nightlife scenes.",
      "Scan Performance: Vermont templates are consistent in scanner checks and perform well when encoded correctly and hand-verified.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Virginia",
    front: "/images/va front.png",
    back: "/images/va back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Good for Virginia college scenes, DC-adjacent nightlife, and regional travel where realistic IDs matter.",
      "Scan Performance: Virginia templates are dependable on common scanners when encoded and verified by our production team.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "West Virginia",
    front: "/images/wv front.png",
    back: "/images/wv back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Works well for West Virginia college towns, local venues, and regional travel across nearby states.",
      "Scan Performance: West Virginia templates show consistent scanning results when produced and encoded to quality standards.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Wisconsin",
    front: "/images/wi front.png",
    back: "/images/wi back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Great for Wisconsin college towns, sports event nightlife, and local venues where appearance and scanability matter.",
      "Scan Performance: Wisconsin templates are reliable on common scanning systems when encoded precisely and verified.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  },
  {
    key: "Wyoming",
    front: "/images/wy front.png",
    back: "/images/wy back.png",
    prices: [
      { label: "1-3 IDs", price: 80, old: 100 },
      { label: "4-9 IDs", price: 65, old: 85 },
      { label: "10+ IDs", price: 50, old: 75 },
    ],
    info: [
      "Features: Ultra-realistic 2024 templates, specialized holograms, scannable barcode, premium card stock, pro printing and hand-verification.",
      "Best Uses: Good for Wyoming college towns, smaller-city nightlife, and regional travel where realistic appearance helps.",
      "Scan Performance: Wyoming templates are consistent in scanner checks when encoded correctly and quality-verified before shipping.",
      "Why Fakelordak47?: Ultra-realistic templates & security features. Every order includes a free duplicate. All IDs are scannable & pass club/bar checks. Discreet US shipping and privacy guaranteed. Legendary support via Telegram/WhatsApp. Professional production & hand-verification of every card. Thousands of happy customers since 2017.",
      "Shipping: Rushed: 5-7 days, tracked to your door. Normal: 12-15 days, tracked. All orders ship in plain packaging, with tracking sent as soon as your order leaves our door.",
      "How do we do it?: We use pro printing, specialized holograms, and real barcode/data encoding. Every card is checked by hand and shipped in plain packaging with tracking."
    ],
  }
];

// --- PRICE ADJUSTMENT ---
const STATES = STATES_DATA.map((s) => ({
  ...s,
  prices: Array.isArray(s.prices)
    ? s.prices.map((p) => ({ ...p, price: p.price === 80 ? 75 : p.price }))
    : s.prices,
}));

// --- Helper Styles ---
const navBtnStyle = (active) => ({
  background: "none",
  border: "none",
  color: active ? ACCENT : "#444",
  fontWeight: active ? 800 : 600,
  fontSize: 18,
  marginRight: 26,
  cursor: "pointer",
  padding: "7px 0",
  borderBottom: active ? `2.5px solid ${ACCENT}` : "none",
});
const inputStyle = {
  width: "100%",
  margin: "7px 0 15px 0",
  padding: "7px 10px",
  borderRadius: 7,
  border: "1.5px solid #eee",
};
const btnStyle = (bg, color = "#fff") => ({
  background: bg,
  color,
  fontWeight: 700,
  border: "none",
  padding: "10px 28px",
  borderRadius: 7,
  fontSize: 17,
  cursor: "pointer",
});

// --- Modal (improved: Escape to close, prevent background scroll, modal content scrollable) ---
function Modal({ isOpen, children, onClose }) {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    // preserve previous overflow to restore exactly when modal closes
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prevOverflow || "";
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(40,35,80,0.09)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16, // add padding so content can touch edges on very small viewports
      }}
      onClick={onClose}
    >
      <div
        style={{
          position: "relative",
          background: "#fff",
          borderRadius: 18,
          boxShadow: "0 4px 28px #ccc",
          maxWidth: 900,
          width: "92vw",
          // CRITICAL: constrain height and make the modal content scrollable
          maxHeight: "90vh",
          overflowY: "auto",
          // enable smooth scrolling on iOS
          WebkitOverflowScrolling: "touch",
          padding: "28px 22px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          style={{
            position: "absolute",
            right: 16,
            top: 12,
            fontSize: 36,
            background: "#fff",
            border: "none",
            color: ACCENT,
            fontWeight: 900,
            borderRadius: "50%",
            boxShadow: "0 2px 8px #ddd",
            cursor: "pointer",
          }}
        >
          &times;
        </button>
        {children}
      </div>
    </div>
  );
}

// --- State Card ---
function StateCard({ state, onOrder, onDetails }) {
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 18,
        boxShadow: "0 6px 18px #e3e3fa",
        padding: 24,
        textAlign: "center",
        border: "2px solid #eee",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: 320,
      }}
    >
      <img
        src={state.front}
        alt={state.key + " ID"}
        style={{
          width: "92%",
          maxWidth: 230,
          minHeight: 120,
          borderRadius: 15,
          marginBottom: 16,
          boxShadow: "0 2px 16px #aaa",
        }}
      />
      <img
        src={state.back}
        alt={state.key + " ID back"}
        style={{
          width: "92%",
          maxWidth: 230,
          minHeight: 120,
          borderRadius: 15,
          marginBottom: 8,
          boxShadow: "0 2px 16px #aaa",
        }}
      />
      <div
        style={{
          fontWeight: 900,
          fontSize: 23,
          marginBottom: 10,
          color: ACCENT,
        }}
      >
        {state.key}
      </div>
      <ul
        style={{
          textAlign: "left",
          fontSize: 15,
          color: "#444",
          margin: "10px 0 8px 0",
          paddingLeft: 20,
        }}
      >
        {Array.isArray(state.info) &&
          state.info.slice(0, 3).map((line, i) => <li key={i}>{line}</li>)}
      </ul>
      <div style={{ marginBottom: 8 }}>
        {Array.isArray(state.prices) &&
          state.prices.map((tier, i) => (
            <div
              key={i}
              style={{ fontSize: 18, color: ACCENT, fontWeight: 700 }}
            >
              {tier.label}: ${tier.price}/ea
              <span
                style={{
                  color: "#888",
                  textDecoration: "line-through",
                  marginLeft: 8,
                  fontWeight: 500,
                }}
              >
                ${tier.old}
              </span>
            </div>
          ))}
      </div>
      <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
        <button
          style={btnStyle("#f37021")}
          onClick={(e) => {
            e.stopPropagation();
            onOrder();
          }}
        >
          Order
        </button>
        <button
          style={btnStyle(ACCENT)}
          onClick={(e) => {
            e.stopPropagation();
            onDetails();
          }}
        >
          Details
        </button>
      </div>
    </div>
  );
}

// --- Details Modal ---
function DetailsModal({ state, onClose }) {
  if (!state) return null;
  return (
    <Modal isOpen={!!state} onClose={onClose}>
      <img
        src={state.front}
        alt={state.key + " Front"}
        style={{
          width: "100%",
          maxWidth: 310,
          borderRadius: 16,
          boxShadow: "0 2px 16px #aaa",
          marginBottom: 16,
        }}
      />
      <img
        src={state.back}
        alt={state.key + " Back"}
        style={{
          width: "100%",
          maxWidth: 310,
          borderRadius: 16,
          boxShadow: "0 2px 16px #aaa",
          marginBottom: 16,
        }}
      />
      <h2
        style={{
          fontWeight: 900,
          fontSize: 30,
          marginBottom: 8,
          color: ACCENT,
        }}
      >
        {state.key} ID
      </h2>
      <ul
        style={{
          textAlign: "left",
          fontSize: 16,
          color: "#444",
          margin: "16px 0 16px 0",
          paddingLeft: 24,
        }}
      >
        {Array.isArray(state.info) &&
          state.info.map((line, i) => <li key={i}>{line}</li>)}
      </ul>
    </Modal>
  );
}

// --- Order Modal (Formspree HTTP API Integration) ---
function OrderModal({ state, onClose, onSubmit }) {
  const [form, setForm] = useState({
    name: "",
    dob: "",
    address: "",
    zipcode: "",
    height: "",
    weight: "",
    gender: "",
    eye: "",
    signature: null,
    photo: null,
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  function handleFile(e, field) {
    if (e.target.files && e.target.files[0]) {
      setForm((f) => ({ ...f, [field]: e.target.files[0] }));
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.photo) {
      setError("ID Photo is required.");
      return;
    }
    setError("");
    setLoading(true);

    // Build FormData
    const orderNum = "#FAKEID-" + Math.floor(100000 + Math.random() * 900000);
    const fd = new FormData();
    fd.append("order_number", orderNum);
    fd.append("state", state.key);
    fd.append("name", form.name);
    fd.append("dob", form.dob);
    fd.append("address", form.address);
    fd.append("zipcode", form.zipcode);
    fd.append("height", form.height);
    fd.append("weight", form.weight);
    fd.append("gender", form.gender);
    fd.append("eye", form.eye);
    fd.append("photo", form.photo); // File object
    if (form.signature) fd.append("signature", form.signature);

    try {
      const resp = await fetch(FORMSPREE_ENDPOINT, {
        method: "POST",
        body: fd,
        headers: { Accept: "application/json" },
      });
      const data = await resp.json();
      if (resp.ok && (data.ok || resp.status === 200)) {
        setLoading(false);
        onSubmit({ ...form, order_number: orderNum }); // Show confirmation modal and add to cart
      } else {
        setLoading(false);
        setError("Submission failed. Try again or contact support.");
      }
    } catch (err) {
      setLoading(false);
      setError("Network error. Try again or contact support.");
    }
  }

  return (
    <Modal isOpen={!!state} onClose={onClose}>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <h2 style={{ fontWeight: 800, fontSize: 22, marginBottom: 12 }}>
          {state ? state.key : "ID"} Info
        </h2>
        <label style={{ fontWeight: 700, marginBottom: 2 }}>Name</label>
        <input
          required
          placeholder="Name"
          style={inputStyle}
          value={form.name}
          onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
        />

        <label style={{ fontWeight: 700, marginBottom: 2 }}>Birth Date</label>
        <input
          required
          type="date"
          placeholder="Birth Date"
          style={inputStyle}
          value={form.dob}
          onChange={(e) => setForm((f) => ({ ...f, dob: e.target.value }))}
        />

        <label style={{ fontWeight: 700, marginBottom: 2 }}>
          Address (optional)
        </label>
        <input
          placeholder="Address"
          style={inputStyle}
          value={form.address}
          onChange={(e) => setForm((f) => ({ ...f, address: e.target.value }))}
        />

        <label style={{ fontWeight: 700, marginBottom: 2 }}>
          Zip Code (optional)
        </label>
        <input
          placeholder="Zip Code"
          style={inputStyle}
          value={form.zipcode}
          onChange={(e) => setForm((f) => ({ ...f, zipcode: e.target.value }))}
        />

        <div style={{ display: "flex", gap: "10px" }}>
          <div style={{ flex: 1 }}>
            <label style={{ fontWeight: 700, marginBottom: 2 }}>Height</label>
            <input
              required
              placeholder="Height"
              style={inputStyle}
              value={form.height}
              onChange={(e) =>
                setForm((f) => ({ ...f, height: e.target.value }))
              }
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ fontWeight: 700, marginBottom: 2 }}>Weight</label>
            <input
              required
              placeholder="Weight"
              style={inputStyle}
              value={form.weight}
              onChange={(e) =>
                setForm((f) => ({ ...f, weight: e.target.value }))
              }
            />
          </div>
        </div>
        <label style={{ fontWeight: 700, marginBottom: 2 }}>Gender</label>
        <select
          required
          style={inputStyle}
          value={form.gender}
          onChange={(e) => setForm((f) => ({ ...f, gender: e.target.value }))}
        >
          <option value="">Gender</option>
          <option>Male</option>
          <option>Female</option>
          <option>Other</option>
        </select>
        <label style={{ fontWeight: 700, marginBottom: 2 }}>Eye Color</label>
        <select
          required
          style={inputStyle}
          value={form.eye}
          onChange={(e) => setForm((f) => ({ ...f, eye: e.target.value }))}
        >
          <option value="">Eye Color</option>
          <option>Brown</option>
          <option>Blue</option>
          <option>Green</option>
          <option>Hazel</option>
          <option>Gray</option>
          <option>Amber</option>
          <option>Other</option>
        </select>
        <label style={{ marginBottom: 7, fontWeight: 700 }}>
          ID Photo <span style={{ color: "#e85c0e" }}>*required</span>
        </label>
        <input
          type="file"
          accept="image/*"
          required
          style={inputStyle}
          onChange={(e) => handleFile(e, "photo")}
        />
        <label style={{ marginBottom: 7, fontWeight: 700 }}>
          Signature Photo (Optional)
        </label>
        <input
          type="file"
          accept="image/*"
          style={inputStyle}
          onChange={(e) => handleFile(e, "signature")}
        />
        {error && <div style={{ color: "red", marginBottom: 10 }}>{error}</div>}
        <button
          type="submit"
          style={{ ...btnStyle(ACCENT), width: "100%" }}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Add to Cart"}
        </button>
      </form>
    </Modal>
  );
}

// --- Cart Modal ---
function CartModal({ cart, onUpdateQty, onRemove, onCheckout, onClose }) {
  const total = cart.reduce((sum, item) => sum + item.qty * item.price, 0);
  return (
    <Modal isOpen={true} onClose={onClose}>
      <h2
        style={{
          fontWeight: 800,
          fontSize: 23,
          marginBottom: 8,
          color: ACCENT,
        }}
      >
        Cart
      </h2>
      {cart.length === 0 ? (
        <div>Your cart is empty.</div>
      ) : (
        cart.map((item, idx) => (
          <div
            key={idx}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: 13,
              borderBottom: "1px solid #eee",
              paddingBottom: 10,
            }}
          >
            {item.state && (
              <img
                src={item.state.front}
                alt={item.state.key}
                style={{ width: 60, borderRadius: 10, marginRight: 12 }}
              />
            )}
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700 }}>
                {item.state ? item.state.key : ""}
              </div>
              <div style={{ color: ACCENT, fontWeight: 700, fontSize: 17 }}>
                Price: ${item.price}
              </div>
              <input
                type="number"
                min={1}
                value={item.qty}
                style={{ width: 50, marginTop: 5 }}
                onChange={(e) =>
                  onUpdateQty(idx, Math.max(1, parseInt(e.target.value)))
                }
              />
              <div style={{ fontSize: 14, color: "#888", marginTop: 5 }}>
                {item.data &&
                  Object.entries(item.data).map(([k, v]) => {
                    if (v instanceof File) {
                      return <span key={k}>{k}: [file uploaded]; </span>;
                    }
                    return v ? (
                      <span key={k}>
                        {k}: {v};{" "}
                      </span>
                    ) : null;
                  })}
              </div>
            </div>
            <button
              onClick={() => onRemove(idx)}
              style={{
                background: "#f37021",
                color: "#fff",
                border: "none",
                borderRadius: 7,
                padding: "7px 12px",
                fontWeight: 700,
              }}
            >
              Remove
            </button>
          </div>
        ))
      )}
      <div style={{ marginTop: 12, fontSize: 18, fontWeight: 700 }}>
        Total: ${total}
      </div>
      <button
        style={btnStyle(ACCENT)}
        onClick={onCheckout}
        disabled={cart.length === 0}
      >
        Checkout
      </button>
    </Modal>
  );
}

// --- Shipping Modal ---
function ShippingModal({ isOpen, onClose, onSubmit }) {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
    state: "",
    zip: "",
  });
  function handleSubmit(e) {
    e.preventDefault();
    onSubmit(form);
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2 style={{ fontWeight: 800, fontSize: 22, marginBottom: 12 }}>
        Shipping Info
      </h2>
      <form onSubmit={handleSubmit}>
        <input
          required
          placeholder="Full Name"
          style={inputStyle}
          value={form.name}
          onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
        />
        <input
          required
          placeholder="Phone Number"
          style={inputStyle}
          value={form.phone}
          onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
        />
        <input
          required
          type="email"
          placeholder="Email"
          style={inputStyle}
          value={form.email}
          onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
        />
        <input
          required
          placeholder="Shipping Address"
          style={inputStyle}
          value={form.address}
          onChange={(e) => setForm((f) => ({ ...f, address: e.target.value }))}
        />
        <input
          required
          placeholder="State"
          style={inputStyle}
          value={form.state}
          onChange={(e) => setForm((f) => ({ ...f, state: e.target.value }))}
        />
        <input
          required
          placeholder="Zip Code"
          style={inputStyle}
          value={form.zip}
          onChange={(e) => setForm((f) => ({ ...f, zip: e.target.value }))}
        />
        <button type="submit" style={{ ...btnStyle(ACCENT), width: "100%" }}>
          Submit Order
        </button>
      </form>
    </Modal>
  );
}

// --- Confirm Modal (LEAD) ---
function ConfirmModal({ cart, shippingInfo, onClose }) {
  const orderNum =
    (cart[0] && cart[0].data && cart[0].data.order_number) ||
    "#FAKEID-" + Math.floor(100000 + Math.random() * 900000);
  return (
    <Modal isOpen={!!cart && !!shippingInfo} onClose={onClose}>
      <h2
        style={{
          fontWeight: 900,
          fontSize: 26,
          color: ACCENT,
          marginBottom: 12,
        }}
      >
        Order Submitted!
      </h2>
      <div style={{ fontSize: 18, color: "#444", marginBottom: 14 }}>
        Thank you! Here is your order info:
      </div>
      <div style={{ fontWeight: 700, color: ACCENT, marginBottom: 12 }}>
        Order Number: {orderNum}
      </div>
      <div style={{ fontSize: 17, color: "#444", marginBottom: 14 }}>
        <b>Shipping Info:</b>
        <br />
        {Object.entries(shippingInfo || {}).map(([k, v]) => (
          <span key={k}>
            {k}: {v}
            <br />
          </span>
        ))}
      </div>
      <div style={{ fontWeight: 700, color: "#444", marginBottom: 10 }}>
        <b>Your IDs:</b>
        {cart.map((item, idx) => (
          <div
            key={idx}
            style={{
              marginTop: 8,
              paddingBottom: 7,
              borderBottom: "1px solid #eee",
            }}
          >
            <b>{item.state ? item.state.key : ""}</b> &nbsp;Qty: {item.qty}
            <br />
            {item.data &&
              Object.entries(item.data).map(([k, v]) => {
                if (v instanceof File) {
                  return <span key={k}>{k}: [file uploaded]; </span>;
                }
                return v ? (
                  <span key={k}>
                    {k}: {v};{" "}
                  </span>
                ) : null;
              })}
          </div>
        ))}
      </div>

      <div style={{ fontSize: 16, color: ACCENT, marginBottom: 14 }}>
        Pay with Bitcoin: <b>{BTC_ADDRESS}</b>
      </div>

      <div style={{ fontSize: 16, color: ACCENT, marginBottom: 14 }}>
        Or card:{" "}
        <a href="https://moonpay.com/" style={{ color: ACCENT }}>
          MoonPay
        </a>
      </div>

      {/* New payment options section */}
      <div style={{ fontSize: 16, color: ACCENT, marginBottom: 14 }}>
        We also accept: <b>PayPal</b>, <b>Venmo</b>, <b>Cash App</b>, and <b>Zelle</b>.
        <div style={{ fontSize: 13, color: "#666", marginTop: 6 }}>
          (Example placeholders — replace with your actual account details)
          <br />
          PayPal: paypal.me/yourlink · Venmo: @yourusername · Cash App: $yourcashtag · Zelle: your@email.com
        </div>
      </div>

      <div style={{ fontSize: 17, color: "#e85c0e", marginBottom: 14 }}>
        <b>
          After payment, send your payment screenshot to{" "}
          <a
            href={`https://t.me/${TELEGRAM}`}
            target="_blank"
            style={{ color: ACCENT }}
          >
            {TELEGRAM}
          </a>{" "}
          or{" "}
          <a href={WHATSAPP_LINK} target="_blank" style={{ color: ACCENT }}>
            WhatsApp
          </a>{" "}
          to confirm your order!
        </b>
      </div>
      <button style={btnStyle(ACCENT)} onClick={onClose}>
        Back to Home
      </button>
    </Modal>
  );
}

// --- About Modal (Long) ---
function AboutModal({ isOpen, onClose }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2
        style={{
          fontWeight: 900,
          fontSize: 34,
          color: ACCENT,
          marginBottom: 24,
        }}
      >
        About Us
      </h2>
      <div
        style={{
          fontSize: 19,
          color: "#444",
          lineHeight: 1.7,
          maxHeight: "60vh",
          overflowY: "auto",
        }}
      >
        Welcome to Fakelordak47, your trusted destination for premium novelty
        IDs since 2017.
        <br />
        <br />
        <b>Why choose us?</b> We combine years of graphic design, printing, and
        security tech experience to deliver IDs that look and feel authentic.
        Every order is produced in-house using ultra-realistic materials,
        advanced hologram overlays, and scannable barcodes. Our IDs are
        indistinguishable from the real thing for parties, clubs, privacy,
        collectibles, and more.
        <br />
        <br />
        We believe in privacy. All orders ship in plain packaging with tracking
        and a free duplicate backup. Your info is kept strictly confidential,
        and our legendary customer support is available 24/7 via Telegram or
        WhatsApp.
        <br />
        <br />
        Since launch, we've helped thousands of customers nationwide get the IDs
        they need quickly, discreetly, and with peace of mind. We constantly
        update products and security features to stay ahead of the curve.
        <br />
        <br />
        <b>Payment:</b> Bitcoin, Cash App, vennmo, paypal, or card—whatever works for you.
        <br />
        <b>Shipping:</b> Fast, discreet, tracked to all 50 states.
        <br />
        <b>Support:</b> Telegram{" "}
        <a
          href={`https://t.me/${TELEGRAM}`}
          target="_blank"
          style={{ color: ACCENT }}
        >
          {TELEGRAM}
        </a>{" "}
        or WhatsApp{" "}
        <a href={WHATSAPP_LINK} target="_blank" style={{ color: ACCENT }}>
          {WHATSAPP}
        </a>
        .<br />
        <br />
        Discover why Fakelordak47 is the #1 choice for novelty IDs. Order now
        and join our loyal community!
      </div>
    </Modal>
  );
}

// --- Guide Modal (Long) ---
function GuideModal({ isOpen, onClose }) {
  const [tab, setTab] = useState(0);
  const GUIDE_TABS = ["How to Pay", "How to Order", "Photo Tips", "Shipping"];
  const GUIDE_CONTENT = [
    <div>
      <b>How to Pay:</b>
      <br />
      We make payment easy and private. We accept <b>Bitcoin</b> (no fees, fully
      anonymous), <b>Cash App</b> (for fast, easy payments using your phone),
      and <b>credit/debit card</b> via MoonPay.
      <br />
      <br />
      After checkout, you'll get step-by-step payment instructions. If using
      Cash App, just send your payment and text your proof (screenshot) to us on
      Telegram or WhatsApp. For Bitcoin, send payment to our address, and upload
      your proof. Card payments via MoonPay are secure and processed instantly.
      <br />
      <br />
      Need help? Chat with us anytime—our support is always online!
    </div>,
    <div>
      <b>How to Order:</b>
      <br />
      1. Choose your state and ID quantity.
      <br />
      2. Fill in your personal details (name, birthdate, etc).
      <br />
      3. Upload a clear photo and signature.
      <br />
      4. Add your IDs to cart, proceed to checkout, and fill your shipping info.
      <br />
      5. After checkout, follow payment instructions and send payment proof.
      <br />
      <br />
      We review your order before production. If anything's missing or needs
      fixing, we'll contact you right away. Every order gets a free duplicate
      backup in case your card is lost.
    </div>,
    <div>
      <b>Photo Tips:</b>
      <br />
      For best results, use a recent smartphone photo against a plain white or
      light background. Make sure your face is fully visible—no hats,
      sunglasses, or filters. Good lighting (natural or soft indoor) is key.
      Look directly at the camera with a neutral expression.
      <br />
      <br />
      JPG or PNG is preferred. If your photo doesn't meet requirements, we'll
      contact you for a new one. Your photo will be professionally cropped and
      enhanced for a flawless ID look!
    </div>,
    <div>
      <b>Shipping:</b>
      <br />
      All orders ship in plain, unbranded packaging—no mention of IDs. We ship
      daily, and every order comes with tracking and a free duplicate backup.
      Shipping is free to all 50 states.
      <br />
      <br />
      Most orders arrive within 3–7 business days. We'll email and message you
      your tracking number as soon as your order ships. If you have any issues,
      contact us for fast resolution.
      <br />
      <br />
      Your privacy is guaranteed—no ID markings on your package, and your info
      is never shared!
    </div>,
  ];
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2
        style={{
          fontWeight: 900,
          fontSize: 28,
          color: ACCENT,
          marginBottom: 18,
        }}
      >
        Guide
      </h2>
      <div style={{ display: "flex", gap: 14, marginBottom: 16 }}>
        {GUIDE_TABS.map((name, i) => (
          <button
            key={name}
            style={{
              background: tab === i ? ACCENT : "#eee",
              color: tab === i ? "#fff" : "#444",
              fontWeight: 700,
              border: "none",
              borderRadius: 7,
              padding: "8px 22px",
              fontSize: 16,
              cursor: "pointer",
            }}
            onClick={() => setTab(i)}
          >
            {name}
          </button>
        ))}
      </div>
      <div
        style={{
          fontSize: 17,
          color: "#444",
          minHeight: 80,
          maxHeight: "40vh",
          overflowY: "auto",
        }}
      >
        {GUIDE_CONTENT[tab]}
      </div>
    </Modal>
  );
}

// --- Reviews Modal ---
function ReviewsModal({ isOpen, onClose }) {
  const proofImg1 = "/images/review1.png";
  const proofImg2 = "/images/review2.png";
  const proofImg3 = "/images/review3.png";
  const [form, setForm] = useState({ name: "", text: "", img: null });
  const [reviews, setReviews] = useState([
    {
      name: "Brandon",
      text: "Looks just like my real ID and scanned everywhere!",
      img: proofImg1,
    },
    {
      name: "Ashley",
      text: "Came fast and works at all clubs, totally legit.",
      img: proofImg2,
    },
    {
      name: "Jake",
      text: "Arrived super quick, scanned perfectly at the bar.",
      img: proofImg3,
    },
    {
      name: "Monica",
      text: "Discreet, realistic, and fast. Will order again!",
    },
    {
      name: "Ethan",
      text: "Great quality, fast shipping. Highly recommend!",
    },
    {
      name: "Sophia",
      text: "Worked everywhere I tried, super easy process.",
    },
    {
      name: "Liam",
      text: "Best fake IDs out there. Customer service is awesome.",
    },
    {
      name: "Olivia",
      text: "Perfect scan, no trouble at the club. 10/10.",
    },
    {
      name: "Noah",
      text: "So realistic, even my friends were impressed.",
    },
    {
      name: "Ava",
      text: "Fantastic experience! Will recommend to friends.",
    },
    {
      name: "Mason",
      text: "ID came quick and works everywhere I need.",
    },
    {
      name: "Isabella",
      text: "Better than expected, looks and feels real.",
    },
  ]);
  function submit(e) {
    e.preventDefault();
    let review = { name: form.name || "Anon", text: form.text };
    if (form.img) review.img = URL.createObjectURL(form.img);
    setReviews([...reviews, review]);
    setForm({ name: "", text: "", img: null });
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2
        style={{
          fontWeight: 900,
          fontSize: 28,
          color: ACCENT,
          marginBottom: 18,
        }}
      >
        Reviews
      </h2>
      <div style={{ marginBottom: 28, maxHeight: "40vh", overflowY: "auto" }}>
        {reviews.map((rev, i) => (
          <div
            key={i}
            style={{
              background: "#f7f7f7",
              borderRadius: 6,
              padding: 14,
              marginBottom: 12,
              fontSize: 17,
            }}
          >
            <span style={{ fontWeight: 700, color: "#8a6d3b" }}>
              {rev.name}
            </span>
            : {rev.text}
            {rev.img && (
              <img
                src={rev.img}
                alt="User Proof"
                style={{
                  display: "block",
                  marginTop: 8,
                  width: 180,
                  borderRadius: 10,
                }}
              />
            )}
          </div>
        ))}
      </div>
      <form onSubmit={submit}>
        <input
          type="text"
          placeholder="Your name (optional)"
          value={form.name}
          style={inputStyle}
          onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
        />
        <textarea
          required
          placeholder="Your review (required)"
          value={form.text}
          style={{ ...inputStyle, minHeight: 60 }}
          onChange={(e) => setForm((f) => ({ ...f, text: e.target.value }))}
        />
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setForm((f) => ({ ...f, img: e.target.files[0] }))}
          style={{ marginBottom: 11 }}
        />
        <button type="submit" style={btnStyle(ACCENT)}>
          Submit
        </button>
      </form>
    </Modal>
  );
}

// --- FAQ Modal ---
function FAQModal({ isOpen, onClose }) {
  const faqs = [
    {
      q: "How many IDs do I get?",
      a: "Every order includes a free duplicate copy.",
    },
    {
      q: "How fast is shipping?",
      a: "Most orders ship in 1 business day and arrive in 3–7 days (US).",
    },
    {
      q: "How do I order?",
      a: "Pick your state, fill info, upload photo, checkout, send payment proof.",
    },
    { q: "Do I get tracking?", a: "Yes, you get tracking info once shipped." },
    {
      q: "What photo should I upload?",
      a: "Plain background, no hats, face camera, good lighting.",
    },
    {
      q: "What if I enter wrong info?",
      a: "Contact support to fix before printing.",
    },
    { q: "Do IDs scan?", a: "Yes, all IDs have working barcodes/magstrips." },
    {
      q: "Will customs seize my package?",
      a: "Shipping is discreet and plain, issues are rare.",
    },
    {
      q: "Can I use this ID for clubs?",
      a: "For novelty use only—be responsible.",
    },
    {
      q: "Is this legit?",
      a: "We've shipped thousands since 2017. Check reviews!",
    },
  ];
  const [open, setOpen] = useState(null);
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2
        style={{
          fontWeight: 900,
          fontSize: 32,
          color: ACCENT,
          marginBottom: 18,
        }}
      >
        FAQ
      </h2>
      <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
        {faqs.map((item, idx) => (
          <div key={idx}>
            <button
              style={{
                width: "100%",
                textAlign: "left",
                background: "#f7f7f7",
                border: "none",
                padding: 14,
                fontSize: 18,
                fontWeight: 700,
                marginBottom: 3,
                borderRadius: "6px",
              }}
              onClick={() => setOpen(open === idx ? null : idx)}
            >
              {open === idx ? "−" : "+"} {item.q}
            </button>
            {open === idx && (
              <div
                style={{
                  background: "#fff",
                  padding: 14,
                  fontSize: 17,
                  marginBottom: 8,
                  borderRadius: "0 0 6px 6px",
                }}
              >
                {item.a}
              </div>
            )}
          </div>
        ))}
      </div>
    </Modal>
  );
}

// --- Contact Modal ---
function ContactModal({ isOpen, onClose }) {
  const [form, setForm] = useState({
    topic: "",
    name: "",
    email: "",
    message: "",
  });
  function submit(e) {
    e.preventDefault();
    alert("Submitted! We'll reply via Telegram or Email.");
    onClose();
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <form onSubmit={submit}>
        <h2
          style={{
            fontWeight: 900,
            fontSize: 28,
            color: ACCENT,
            marginBottom: 18,
          }}
        >
          Contact Us
        </h2>
        <select
          required
          value={form.topic}
          onChange={(e) => setForm((f) => ({ ...f, topic: e.target.value }))}
          style={{ ...inputStyle, marginBottom: 12 }}
        >
          <option value="">Select Topic</option>
          <option value="Order Help">Order Help</option>
          <option value="Payment">Payment</option>
          <option value="Shipping">Shipping</option>
          <option value="General Question">General Question</option>
        </select>
        <input
          required
          placeholder="Name"
          value={form.name}
          onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
          style={inputStyle}
        />
        <input
          required
          type="email"
          placeholder="Email"
          value={form.email}
          onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
          style={inputStyle}
        />
        <textarea
          required
          placeholder="Message"
          value={form.message}
          onChange={(e) => setForm((f) => ({ ...f, message: e.target.value }))}
          style={{ ...inputStyle, minHeight: 70 }}
        />
        <button type="submit" style={btnStyle(ACCENT)}>
          Send
        </button>
      </form>
    </Modal>
  );
}

// --- Products Modal (shows the rest of the products beyond the first 10) ---
function ProductsModal({ isOpen, onClose, onOrder, onDetails }) {
  // show items after the first 10
  const rest = STATES.slice(10);
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2
        style={{
          fontWeight: 900,
          fontSize: 28,
          color: ACCENT,
          marginBottom: 18,
        }}
      >
        All Products
      </h2>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: 22,
        }}
      >
        {rest.map((state) => (
          <StateCard
            key={state.key}
            state={state}
            onOrder={() => onOrder(state)}
            onDetails={() => onDetails(state)}
          />
        ))}
      </div>
      <div style={{ textAlign: "center", marginTop: 18 }}>
        <button style={btnStyle(ACCENT)} onClick={onClose}>
          Back to Home
        </button>
      </div>
    </Modal>
  );
}

// --- Main App ---
export default function App() {
  const [modal, setModal] = useState("");
  const [detailsState, setDetailsState] = useState(null);
  const [orderState, setOrderState] = useState(null);
  const [cart, setCart] = useState([]);
  const [showShipping, setShowShipping] = useState(false);
  const [shippingInfo, setShippingInfo] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmedOrder, setConfirmedOrder] = useState([]);
  const [showContact, setShowContact] = useState(false);

  // small lock to prevent double-click/open glitches on "View all products"
  const [openingProducts, setOpeningProducts] = useState(false);

  useEffect(() => {
    // inject Google Analytics gtag script once
    if (!GA_ID) return;
    if (window && window.dataLayer) {
      // already loaded
      return;
    }
    // create dataLayer and gtag stub
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GA_ID);

    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    // no cleanup: keep analytics loaded for session
  }, []);

  function getBulkPrice(prices, qty) {
    if (!Array.isArray(prices)) return 0;
    if (qty >= 10) return prices[2]?.price || 0;
    if (qty >= 4) return prices[1]?.price || 0;
    return prices[0]?.price || 0;
  }
  function handleAddToCart(state, data) {
    if (!state) return;
    setCart([
      ...cart,
      {
        state,
        qty: 1,
        price: getBulkPrice(state.prices, 1),
        data,
      },
    ]);
    setOrderState(null);
    setDetailsState(null);
    setModal("cart");
  }
  function updateQty(idx, qty) {
    setCart(
      cart.map((item, i) =>
        i === idx
          ? { ...item, qty, price: getBulkPrice(item.state.prices, qty) }
          : item
      )
    );
  }
  function removeItem(idx) {
    setCart(cart.filter((_, i) => i !== idx));
  }
  function handleCheckout() {
    setModal("");
    setShowShipping(true);
  }
  function handleShippingSubmit(info) {
    setShippingInfo(info);
    setShowShipping(false);
    setConfirmedOrder(cart);
    setShowConfirm(true);
    setCart([]);
  }
  function handleConfirmClose() {
    setShowConfirm(false);
    setShippingInfo(null);
    setConfirmedOrder([]);
  }

  // homepage list: first 10 products only
  const homepageStates = STATES.slice(0, 10);

  // openProducts: use a quick lock and defer the modal open to the next tick to avoid
  // accidental event propagation or "double mount" race conditions that can cause UI glitches.
  function openProducts() {
    if (openingProducts) return;
    setOpeningProducts(true);

    // clear transient detail/order state so only the products modal is shown
    setDetailsState(null);
    setOrderState(null);

    // Defer modal change to next tick - this prevents cases where the same click event
    // might also trigger an overlay close or other unexpected behavior.
    setTimeout(() => {
      setModal("products");
      // move focus/scroll to top for accessibility and consistent UX
      try {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } catch (err) {
        // ignore in non-browser environments
      }
      // small cooldown to prevent double-clicks
      setTimeout(() => setOpeningProducts(false), 350);
    }, 0);
  }

  return (
    <div style={{ background: "#f7f7f7", minHeight: "100vh" }}>
      <header
        style={{
          background: "#fff",
          borderBottom: "1.5px solid #eee",
          padding: "18px 0",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "sticky",
          top: 0,
          zIndex: 10,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", marginLeft: 36 }}>
          <span
            style={{
              fontWeight: 700,
              fontSize: 34,
              color: "#8a6d3b",
              fontFamily: "serif",
              marginRight: 40,
            }}
          >
            Fakelordak47
          </span>
          <nav style={{ display: "flex", alignItems: "center" }}>
            <button
              onClick={() => setModal("")}
              style={navBtnStyle(modal === "")}
            >
              Home
            </button>
            {/* Use the same openProducts helper here so the openingProducts lock applies
                whether the user clicks the nav "Products" or the "View all products" button */}
            <button
              onClick={openProducts}
              style={navBtnStyle(modal === "products")}
            >
              Products
            </button>
            <button
              onClick={() => setModal("about")}
              style={navBtnStyle(modal === "about")}
            >
              About
            </button>
            <button
              onClick={() => setModal("guide")}
              style={navBtnStyle(modal === "guide")}
            >
              Guide
            </button>
            <button
              onClick={() => setModal("reviews")}
              style={navBtnStyle(modal === "reviews")}
            >
              Reviews
            </button>
            <button
              onClick={() => setShowContact(true)}
              style={navBtnStyle(showContact)}
            >
              Contact
            </button>
            <button
              onClick={() => setModal("faq")}
              style={navBtnStyle(modal === "faq")}
            >
              FAQ
            </button>
            <button
              onClick={() => setModal("cart")}
              style={navBtnStyle(modal === "cart")}
            >
              Cart ({cart.length})
            </button>
          </nav>
        </div>
        <div style={{ marginRight: 36 }}>
          <a
            href={`https://t.me/${TELEGRAM}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: ACCENT,
              fontWeight: 700,
              fontSize: 17,
              textDecoration: "none",
            }}
          >
            Telegram: {TELEGRAM}
          </a>
          <span
            style={{
              marginLeft: 18,
              fontWeight: 700,
              color: "#1ecb45",
              fontSize: 17,
            }}
          >
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              style={{ color: "#1ecb45", textDecoration: "none" }}
            >
              WhatsApp
            </a>
          </span>
        </div>
      </header>

      {modal === "" && (
        <main
          style={{
            maxWidth: 1000,
            margin: "54px auto",
            background: "#fff",
            borderRadius: 18,
            boxShadow: "0 4px 24px #e2e2e2",
            padding: "56px 42px",
          }}
        >
          {/* Improved SALE BANNER with inline SVG graphic */}
          <div
            role="region"
            aria-label="Winter sale"
            style={{
              width: "100%",
              background: "linear-gradient(90deg,#4f46e5,#7c66ff)",
              color: "#fff",
              padding: "14px 18px",
              borderRadius: 12,
              textAlign: "center",
              fontWeight: 900,
              marginBottom: 18,
              fontSize: 18,
              boxShadow: "0 6px 18px rgba(99,91,255,0.12)",
              display: "flex",
              alignItems: "center",
              gap: 14,
              justifyContent: "center",
            }}
          >
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              {/* simple snowflake SVG */}
              <svg
                width="36"
                height="36"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M12 2v4M12 18v4M4.2 4.2l2.8 2.8M17 17l2.8 2.8M2 12h4M18 12h4M4.2 19.8l2.8-2.8M17 7l2.8-2.8"
                  stroke="#fff"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle cx="12" cy="12" r="1.6" fill="#fff" />
              </svg>
              Winter Sale — Now $75 per ID (was $100)
            </span>
            <span style={{ fontWeight: 700, fontSize: 15, opacity: 0.95 }}>
              Free duplicate + free shipping for a limited time
            </span>
          </div>

          <img
            src={MAIN_PAGE_IMAGE}
            alt="Main Page Promo"
            style={{
              width: "100%",
              maxWidth: 800,
              display: "block",
              margin: "0 auto 44px auto",
              borderRadius: 18,
              boxShadow: "0 10px 50px #bbb",
              objectFit: "cover",
            }}
          />
          <h2
            style={{
              fontSize: 32,
              marginBottom: 44,
              textAlign: "center",
              color: "#8a6d3b",
              fontWeight: 900,
              letterSpacing: "0.03em",
            }}
          >
            Select State IDs to Order
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: 38,
            }}
          >
            {homepageStates.map((state) => (
              <StateCard
                key={state.key}
                state={state}
                onOrder={() => {
                  setOrderState(state);
                  setModal("order");
                }}
                onDetails={() => {
                  setDetailsState(state);
                  setModal("details");
                }}
              />
            ))}
          </div>

          <div style={{ textAlign: "center", marginTop: 28 }}>
            <button
              style={{
                ...btnStyle(ACCENT),
                opacity: openingProducts ? 0.7 : 1,
                pointerEvents: openingProducts ? "none" : "auto",
              }}
              onClick={openProducts}
              disabled={openingProducts}
            >
              View all products
            </button>
          </div>

          <div
            style={{
              margin: "54px auto 0 auto",
              maxWidth: 1000,
              padding: "40px 32px",
              background: "#f8f7f5",
              borderRadius: 16,
              boxShadow: "0 2px 24px #eee",
            }}
          >
            <h2
              style={{
                fontWeight: 900,
                fontSize: 28,
                color: ACCENT,
                marginBottom: 18,
              }}
            >
              About Fakelordak47
            </h2>
            <div
              style={{
                marginTop: 22,
                display: "flex",
                gap: 22,
                alignItems: "center",
              }}
            >
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 38,
                  height: 38,
                  background: "#23c23b",
                  borderRadius: "50%",
                  color: "#fff",
                  fontWeight: 900,
                  fontSize: 28,
                }}
              >
                $
              </span>
              <span style={{ fontWeight: 700, color: ACCENT }}>
                Pay with Cash App?{" "}
                <b>
                  Text payment proof to Telegram or WhatsApp after checkout!
                </b>
              </span>
            </div>
            <div
              style={{
                fontSize: 16,
                color: ACCENT,
                marginTop: 32,
                textAlign: "center",
              }}
            >
              Questions? Chat with us on Telegram:{" "}
              <a
                href={`https://t.me/${TELEGRAM}`}
                target="_blank"
                style={{ color: ACCENT, fontWeight: 700 }}
              >
                {TELEGRAM}
              </a>
            </div>
          </div>
        </main>
      )}

      {modal === "details" && detailsState && (
        <DetailsModal state={detailsState} onClose={() => setModal("")} />
      )}
      {modal === "order" && orderState && (
        <OrderModal
          state={orderState}
          onClose={() => setModal("")}
          onSubmit={(data) => handleAddToCart(orderState, data)}
        />
      )}
      {modal === "cart" && (
        <CartModal
          cart={cart}
          onUpdateQty={updateQty}
          onRemove={removeItem}
          onCheckout={handleCheckout}
          onClose={() => setModal("")}
        />
      )}
      {showShipping && (
        <ShippingModal
          isOpen={showShipping}
          onClose={() => setShowShipping(false)}
          onSubmit={handleShippingSubmit}
        />
      )}
      {showConfirm && shippingInfo && (
        <ConfirmModal
          cart={confirmedOrder}
          shippingInfo={shippingInfo}
          onClose={handleConfirmClose}
        />
      )}
      {modal === "about" && (
        <AboutModal isOpen={true} onClose={() => setModal("")} />
      )}
      {modal === "guide" && (
        <GuideModal isOpen={true} onClose={() => setModal("")} />
      )}
      {modal === "reviews" && (
        <ReviewsModal isOpen={true} onClose={() => setModal("")} />
      )}
      {modal === "faq" && (
        <FAQModal isOpen={true} onClose={() => setModal("")} />
      )}
      {showContact && (
        <ContactModal isOpen={true} onClose={() => setShowContact(false)} />
      )}

      {/* Products modal shows the rest of the states beyond the first 10 */}
      {modal === "products" && (
        <ProductsModal
          isOpen={true}
          onClose={() => setModal("")}
          onOrder={(s) => {
            setOrderState(s);
            setModal("order");
          }}
          onDetails={(s) => {
            setDetailsState(s);
            setModal("details");
          }}
        />
      )}

      <div
        style={{
          fontSize: 16,
          color: ACCENT,
          margin: "40px auto 18px auto",
          textAlign: "center",
        }}
      >
        Questions? Chat with us on Telegram:{" "}
        <a
          href={`https://t.me/${TELEGRAM}`}
          target="_blank"
          style={{ color: ACCENT, fontWeight: 700 }}
        >
          {TELEGRAM}
        </a>
      </div>
    </div>
  );
}